import { render, staticRenderFns } from "./IconBatchImport.vue?vue&type=template&id=c5fe6974&scoped=true"
import script from "./IconBatchImport.vue?vue&type=script&lang=js"
export * from "./IconBatchImport.vue?vue&type=script&lang=js"
import style0 from "./IconBatchImport.vue?vue&type=style&index=0&id=c5fe6974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_574b8669d18f67ce8fdb77c3b9cb8ea1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fe6974",
  null
  
)

export default component.exports